import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    topic_id: "",
    avatar_frames: []
  },
  mutations: {},
  actions: {}
});
